import { render } from "./action-modal.html?vue&type=template&id=46864efe&scoped=true&ts=true&external"
import script from "./action-modal.ts?vue&type=script&lang=ts&external"
export * from "./action-modal.ts?vue&type=script&lang=ts&external"

import "./action-modal.scss?vue&type=style&index=0&id=46864efe&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46864efe"]])

export default __exports__